
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    CloseButton,
    IfComp,
    PanelSectionTitle,
    ToolbarCommandButton
} from '../../../core';

import { sagas as sagasMap } from '../../../map';

import { getDatawin } from '../../reducers';
import { getObject } from '../../reducers/datawin';
import { calculateObjectKeyForDocument } from '../../reducers/document';
import { getActions } from '../../sagas';

import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItem';
import {
    useDataModelOperationDelete,
    useDataModelOperationUpdate
} from '../../hooks/useDataModelOperation';

import ObjectDetailInfo from '../objectDetail/ObjectDetailInfo';
import DocumentPanel from '../document/DocumentPanel';

const ObjectPanel = ({appActions}) => {

    const classNames = mergeStyleSets({
        ObjectPanel: {
            marginLeft: 8,
            paddingLeft: 16,
            paddingTop: 16,
            boxShadow: 'rgba(0, 0, 0, 0.1) -8px 0px 8px -8px',
            width: 340
        },
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);
    const mapActions = sagasMap.getActions(dispatch);

    const dataModelItem = useDatawinDataModelItem();
    const object = useSelector(state => getObject(getDatawin(state.data)));
    const operationDelete = useDataModelOperationDelete(dataModelItem);
    const operationUpdate = useDataModelOperationUpdate(dataModelItem);

    const getObjectKey = () => {
        return (dataModelItem && object)
            ? calculateObjectKeyForDocument(object, dataModelItem.attachedDocuments)
            : null;
    }

    const handleCloseClick = () => {
        dataActions.setDatawinObject(null);
    }

    const handleToMapClick = () => {
        appActions.setUiValue('activeWindow', 'map');
        appActions.setUiValue('activePanelName', 'data');
        dataActions.setObjectList([object], true);
        dataActions.setObject(object);
        dataActions.setDatawinObject(null);
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE',
            {
                geoJson: object.attributes._geom,
                zoomToFeature: true
            }
        );
    }

    let commands = [];

    /* ToDo:

    if (operationDelete) {
        commands.push({
            text: 'Smazat',
            title: 'Smazat objekt',
            disabled: true,
            //onClick: handleDeleteClick
        });
    }
    if (operationUpdate) {
        commands.push({
            text: 'Editovat',
            title: 'Editovat parametry objekt',
            disabled: true,
            //onClick: handleUpdateClick
        });
    }
    */

    commands.push({
        text: 'Do mapy',
        title: 'Zobrazit objekt ve 2D mapovém okně',
        onClick: handleToMapClick
    });
    commands.push({
        text: 'Zavřít',
        title: 'Zavřít panel s informací o objektu',
        onClick: handleCloseClick
    });

    return (
        <IfComp cond={object}>
            <Stack verticalFill className={classNames.ObjectPanel} >
                <Stack horizontal verticalAlign="center" >
                    <Stack.Item grow>
                        <PanelSectionTitle title={dataModelItem.title} />
                    </Stack.Item>
                    <CloseButton onClick={handleCloseClick} />
                </Stack>

                <ObjectDetailInfo
                    dataModel={dataModelItem}
                    titleVisible={false}
                    object={object}
                />
                <ToolbarCommandButton
                    items={commands}
                />
                <IfComp cond={dataModelItem && dataModelItem.attachedDocuments}>
                    <DocumentPanel
                        objectKey={getObjectKey()}
                        readOnly={!operationUpdate}
                    />
                </IfComp>
            </Stack>
        </IfComp>
    );
}

export default ObjectPanel;
